import React, {useEffect, useRef, useState} from 'react';
import {Card} from "primereact/card";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {FileUpload} from "primereact/fileupload";
import {Button} from "primereact/button";
import {InputTextarea} from "primereact/inputtextarea";
import "react-quill/dist/quill.snow.css";
import {useParams, useSearchParams} from "react-router-dom";
import {webInfo} from "../../../../utils/webInfo";
import useApi from "../../../../hooks/useApi";
import {Badge} from "primereact/badge";
import callToast, {catchError, depots, getDivisionWiseUrl, showErrors} from "../../../../utils/helper";
import {Skeleton} from "primereact/skeleton";
import useDelete from "../../../../hooks/useDelete";
import usePost from "../../../../hooks/usePost";
import {Dialog} from "primereact/dialog";
import Keyfacts from "./Keyfacts";
import {Toast} from "primereact/toast";
import TextEditor from "../../../../components/TextEditor";

const HerbalDetails = () => {
    const toast = useRef<any>(null);
    const {id} = useParams();
    const [visible, setVisible] = useState(false);
    const [searchParams] = useSearchParams();
    const url = searchParams.get("url");
    const division = searchParams.get("division");
    const {get,loading} = useApi<any>();
    const {remove,loading:rloading} = useDelete();
    const {post,loading:ploading} = usePost();
    const link = `${webInfo.baseUrl}/api/admin/${url}/${id}`;
    const categoryUrl = `${webInfo.baseUrl}/api/admin/products-${getDivisionWiseUrl(division)?.url}-category?page=1&per_page=200`;
    const [categories,setCategories] = useState([]);
    const [mImage, setMImage] = useState<any>(null);
    const [preview, setPreview] = useState<string>("");
    const [refresh, setRefresh] = useState<boolean>(false);
    const fileInputRef = React.useRef<HTMLInputElement>(null);

    const [product, setProduct] = useState({
        brand_name: "",
        product_name: "",
        category:{name:"Select Category",code:null},
        indication: "",
        dosage: "",
        health_benefit: "",
        images: [{id: 1, image: "",preview:false}],
        image: "",
        details_pdf:"",
        product_herbal_category_id:null,
        pack_size: "",
        key_facts:[],
        meta_title: "",
        meta_image: "",
        meta_description: "",
        meta_robots: "",
        meta_author: "",
        meta_keywords: "",
    });

    const handleChange = (e: any) => {
        setProduct({
            ...product,
            [e.target.name]: e.target.value,
        })
    }

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const res: any = await get(link);
                setProduct(res.data);
            } catch (err) {
                console.error("Failed to fetch product", err);
            }
        };

        fetchProducts();
        // eslint-disable-next-line
    }, [url, division, refresh]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res: any = await get(categoryUrl);
                const options = res.data.data.map((item:any)=>{
                    return {
                        name: item.name,
                        code: item.id,
                    }
                })
                setCategories(options);
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        };
        fetchCategories();
        // eslint-disable-next-line
    }, [division]);




    const onUploadProductImage = (event: any) => {
        setProduct({
            ...product,
            image: event.files[0],
        })
    };

    const onRemoveProductImage = () => {
        setProduct({
            ...product,
            image: ""
        })
    };

    const defaultImagePreviewer = () => {
        return (
            <div
                className="flex align-items-center cursor-pointer"
            >
                {product.image ? (
                    <div className="p-fileupload-preview flex justify-content-between items-center w-full">
                        <div className="flex">
                            <img
                                alt="Default"
                                src={`${webInfo.baseUrl}/${product?.image}`} height="50"/>
                            <div className="ml-2">
                                <p className="mb-2">{product?.image.split("/").at(-1)}</p>
                                <div className="flex align-items-center">
                                    <p className="m-0">00.00 KB</p>
                                    <Badge className="ml-2" value="Default"></Badge>
                                </div>
                            </div>
                        </div>
                        <Button onClick={()=>setProduct({...product,image: ""})} icon="pi pi-times" className="mr-2" rounded text severity="danger" aria-label="Cancel" />
                    </div>) : (
                    <>
                        <span style={{
                            fontSize: '1em',
                            color: 'var(--text-color-secondary)'
                        }}>
                            Upload Image
                        </span>
                    </>
                )}
            </div>
        )
    }

    const defaultMetaImagePreviewer = () => {
        return (
            <div
                className="flex align-items-center cursor-pointer"
            >
                {product.meta_image ? (
                    <div className="p-fileupload-preview flex justify-content-between items-center w-full">
                        <div className="flex">
                            <img
                                alt="Default"
                                src={`${webInfo.baseUrl}/${product?.meta_image}`} height="50"/>
                            <div className="ml-2">
                                <p className="mb-2">{product?.meta_image.split("/").at(-1)}</p>
                                <div className="flex align-items-center">
                                    <p className="m-0">00.00 KB</p>
                                    <Badge className="ml-2" value="Default"></Badge>
                                </div>
                            </div>
                        </div>
                        <Button onClick={()=>setProduct({...product,meta_image: ""})} icon="pi pi-times" className="mr-2" rounded text severity="danger" aria-label="Cancel" />
                    </div>) : (
                    <>
                        <span style={{
                            fontSize: '1em',
                            color: 'var(--text-color-secondary)'
                        }}>
                            Upload Image
                        </span>
                    </>
                )}
            </div>
        )
    }


    const defaultPdfPreviewer = () => {
        return (
            <div
                className="flex align-items-center cursor-pointer"
            >
                {product.details_pdf ? (
                    <div className="p-fileupload-preview flex justify-content-between items-center w-full">
                        <div className="flex">
                            <img
                                alt="Default"
                                src={`/pdf.jpg`} height="50"/>
                            <div className="ml-2">
                                <p className="mb-2">{product?.details_pdf?.split("/").at(-1)}</p>
                                <div className="flex align-items-center">
                                    <p className="m-0">00.00 KB</p>
                                    <Badge className="ml-2" value="Default"></Badge>
                                </div>
                            </div>
                        </div>
                        <Button onClick={()=>setProduct({...product,details_pdf: ""})} icon="pi pi-times" className="mr-2" rounded text severity="danger" aria-label="Cancel" />
                    </div>) : (
                    <>
                        <span style={{
                            fontSize: '1em',
                            color: 'var(--text-color-secondary)'
                        }}>
                            Upload Image
                        </span>
                    </>
                )}
            </div>
        )
    }
    const onUploadPdf = (event: any) => {
        setProduct({
            ...product,
            details_pdf: event.files[0],
        })
    };
    const onRemovePdf = () => {
        setProduct({
            ...product,
            details_pdf: "",
        })
    };

    const onMetaUpload = (event: any) => {
        setProduct({
            ...product,
            meta_image: event.files[0],
        })
    };
    const onMetaRemove = () => {
        setProduct({
            ...product,
            meta_image: "",
        })
    };

    const updateProduct = async ()=>{
        const url = `${webInfo.baseUrl}/api/admin/products-${getDivisionWiseUrl(division)?.url}/${id}`;
        const formData = new FormData();
        const payload:any = {
            ...product,
        }
        // for (const key in payload) {
        //     const value = payload[key as keyof typeof payload];
        //     if (value !== null && value.length > 0) {
        //         if (key === "image" && typeof value === "string") continue;
        //         if (key === "meta_image" && typeof value === "string") continue;
        //         if (key === "details_pdf" && typeof value === "string") continue;
        //         if (key === "key_facts") continue;
        //         if (key === "images") continue;
        //         formData.append(key, payload[key]);
        //     }
        // }
        for (const key in payload) {
            const value = payload[key as keyof typeof payload];
            if (value === null || value === undefined) continue;
            if (key === "key_facts" || key === "images") continue;
            if (key === "image" && typeof value === "string") continue;
            if (key === "meta_image" && typeof value === "string") continue;
            if (key === "details_pdf" && typeof value === "string") continue;
            if (value instanceof File) {
                formData.append(key, value);
                continue;
            }
            if (Array.isArray(value) && value.length > 0) {
                value.forEach((item) => formData.append(`${key}[]`, item));
                continue;
            }
            if (typeof value === "string" && value.length > 0) {
                formData.append(key, value);
            }

            if (typeof value === "number" && !isNaN(value)) {
                formData.append(key, String(value));
            }
            if (Array.isArray(product?.key_facts) && product.key_facts.length > 0) {
                product.key_facts.forEach((item: any, index: number) => {

                    if (typeof item?.title === "string" && item.title.length > 0) {
                        formData.append(`key_facts[${index}][title]`, item.title);
                    }

                    if (typeof item?.description === "string" && item.description.length > 0) {
                        formData.append(`key_facts[${index}][description]`, item.description);
                    }

                    if (item?.image instanceof File) {
                        formData.append(`key_facts[${index}][image]`, item.image);
                    }
                });
            }


        }
        try {
            // @ts-ignore
            const res:any = await post(url,false,formData);
            if (res.success){
                callToast(toast,true,res.message)
                // setRefresh(prev=>!prev)
            }else {
                showErrors(res.error?.message || res.error,toast);
            }
        }catch (e) {
            catchError(e)
        }
    }

    if (loading){
        return <Card>
            <div>
                <div className="grid mt-3">
                    {/* LEFT SIDE – PRODUCT INFO (7 COLS) */}
                    <div className="col-12 md:col-7">
                        <div className="p-fluid grid mb-3">
                            <div className="col-12 md:col-12">
                                <Skeleton className="w-full" height="3rem"></Skeleton>
                            </div>
                        </div>
                        <div className="p-fluid grid mb-3">
                            <div className="col-12 md:col-6">
                                <Skeleton className="w-full" height="3rem"></Skeleton>
                            </div>
                            <div className="col-12 md:col-6">
                                <Skeleton className="w-full" height="3rem"></Skeleton>
                            </div>
                        </div>
                        <div className="p-fluid grid mb-3">
                            <div className="col-12 md:col-12">
                                <Skeleton className="w-full" height="10rem"></Skeleton>
                            </div>
                        </div>
                        <div className="p-fluid grid mb-3">
                            <div className="col-12 md:col-12">
                                <Skeleton className="w-full" height="10rem"></Skeleton>
                            </div>
                        </div>
                        <div className="p-fluid grid mb-3">
                            <div className="col-12 md:col-12">
                                <Skeleton className="w-full" height="10rem"></Skeleton>
                            </div>
                        </div>
                        <div className="p-fluid grid mb-3">
                            <div className="col-12 md:col-12">
                                <Skeleton className="w-full" height="10rem"></Skeleton>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-5">
                        <div className="p-fluid grid mb-3">
                            <div className="col-12 md:col-2">
                                <Skeleton className="w-full" height="3rem"></Skeleton>
                            </div>
                        </div>
                        <div className="p-fluid grid mb-3">
                            <div className="col-12 md:col-12">
                                <Skeleton className="w-full" height="3rem"></Skeleton>
                            </div>
                            <div className="col-12 md:col-12">
                                <Skeleton className="w-full" height="3rem"></Skeleton>
                            </div>
                        </div>
                        <div className="p-fluid grid mb-3">
                            <div className="col-12 md:col-2">
                                <Skeleton className="w-full" height="3rem"></Skeleton>
                            </div>
                        </div>
                        <div className="p-fluid grid mb-5">
                            <div className="col-12 md:col-12">
                                <Skeleton className="w-full" height="3rem"></Skeleton>
                            </div>
                            <div className="col-12 md:col-12">
                                <Skeleton className="w-full" height="3rem"></Skeleton>
                            </div>
                        </div>
                        <div className="p-fluid grid mt-5">
                            <div className="col-12 md:col-12">
                                <Skeleton className="w-full" height="3rem"></Skeleton>
                            </div>
                            <div className="col-12 md:col-12">
                                <Skeleton className="w-full" height="3rem"></Skeleton>
                            </div>
                            <div className="col-12 md:col-12">
                                <Skeleton className="w-full" height="10rem"></Skeleton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    }

    const deleteImage = async (id:any)=>{

        const url = `${webInfo.baseUrl}/api/admin/products-${getDivisionWiseUrl(division)?.url}/images-delete/${id}`
        const res:any = await remove(url)
        if (res.success){
            const filtered = product.images.filter(
                (img: any) => img.id !== id
            );

            setProduct({
                ...product,
                images: filtered
            });
        }

    }



    const handleImage = (e: any) => {
        const file = e.target.files[0];

        if (file) {
            setMImage(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const uploadImage = async () => {
        const formData = new FormData();
        formData.append("image", mImage);
        const url = `${webInfo.baseUrl}/api/admin/products-${getDivisionWiseUrl(division)?.url}/images-store/${id}`
        try {
            // @ts-ignore
            const res:any = await post(url,false,formData);
            if (res.success){
                const id = product?.images?.at(-1)?.id || 0
                setProduct({
                    ...product,
                    images: [...product?.images,{id:id+1,image:preview,preview:true}],
                })
                setVisible(false)
                setMImage(null)
                setPreview("")
                setRefresh(!refresh)
            }
        }catch (e) {
            catchError(e)
        }
    };
    const header = (
        <div className='flex align-items-center justify-content-between p-4 pb-0'>
            <h4 className="m-0">Product Details || {depots[2].name}</h4>
        </div>
    )

    return (
        <Card header={header}>
            <Toast ref={toast} />
            <Dialog
                header="Multiple Image"
                visible={visible}
                style={{ width: "20vw" }}
                onHide={() => {
                    setVisible(false)
                    setMImage(null)
                    setPreview("")
                }}
            >
                {
                    ploading ? <div>
                            <Skeleton className="w-full mb-2" height="16rem"></Skeleton>
                            <Skeleton className="w-full mb-2" height="3rem"></Skeleton>
                            <Skeleton className="w-full" height="3rem"></Skeleton>
                        </div> :
                        <div>
                            {preview && (
                                <div className="mb-3 text-center">
                                    <img
                                        src={preview}
                                        alt="preview"
                                        style={{
                                            width: "100%",
                                            maxHeight: "200px",
                                            objectFit: "cover",
                                            borderRadius: "6px",
                                        }}
                                    />
                                </div>
                            )}
                            <div className="flex flex-column gap-2 mb-3">
                                <div className="p-inputgroup">
                                    <InputText
                                        readOnly
                                        value={mImage instanceof File ? mImage.name : "No file chosen"}
                                        placeholder="Choose Image"
                                        onClick={() => fileInputRef.current?.click()}
                                    />
                                    <Button
                                        type="button"
                                        icon="pi pi-upload"
                                        label="Browse"
                                        onClick={() => fileInputRef.current?.click()}
                                    />
                                </div>

                                {/* The ACTUAL file input is hidden */}
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    accept="image/*"
                                    onChange={handleImage}
                                />
                            </div>
                            <Button
                                className="w-full"
                                label="Upload"
                                onClick={uploadImage}
                            />
                        </div>
                }
            </Dialog>
            <div className="grid">
                <div className="col-12 md:col-7">
                    <div className="pr-2">
                        <div className="p-fluid grid">
                            {/* Product Name */}
                            <div className="col-12 md:col-12">
                                <label className="font-medium">Brand Name *</label>
                                <InputText
                                    value={product.brand_name}
                                    onChange={(e) =>
                                        setProduct({ ...product, brand_name: e.target.value })
                                    }
                                    placeholder="Enter product name"
                                />
                            </div>



                            <div className="col-12 md:col-6">
                                <label className="font-medium">Product Name *</label>
                                <InputText
                                    value={product.product_name}
                                    onChange={(e) =>
                                        setProduct({ ...product, product_name: e.target.value })
                                    }
                                    placeholder="Enter product name"
                                />
                            </div>

                            <div className="col-12 md:col-6">
                                <label className="font-medium">Category *</label>
                                <Dropdown
                                    value={categories?.find((item:any)=>Number(item?.code)===Number(product.product_herbal_category_id))}
                                    options={categories}
                                    optionLabel="name"
                                    onChange={(e) =>
                                        setProduct({ ...product, product_herbal_category_id: e.value.code })
                                    }
                                    placeholder="Select Category"
                                    className="w-full"
                                />
                            </div>

                            <div className="col-12">
                                <label className="font-medium">Product Image (1024 kB max) *</label>
                                <FileUpload
                                    name="demo[]"
                                    url="/api/upload"
                                    multiple={false}
                                    accept="image/*"
                                    maxFileSize={1024*1024}
                                    emptyTemplate={defaultImagePreviewer}
                                    onSelect={onUploadProductImage}
                                    onRemove={onRemoveProductImage}
                                />

                            </div>

                            <div className="col-12">
                                <div>
                                    <div className="flex justify-content-between w-full">
                                        <label className="font-medium">Multiple Images (1024 kB max / Image)</label>
                                        <Button
                                            label="Add New"
                                            style={{width: 'fit-content'}}
                                            icon="pi pi-plus"
                                            onClick={() => setVisible(true)}
                                        />
                                    </div>

                                    {product?.images?.map((item: any) => {
                                        const prev = item.preview ? item.image : typeof item.image === "string" ? item.image ? `${webInfo.baseUrl}/${item.image}` : "" : item.image ? URL.createObjectURL(item.image) : "";
                                        return (
                                            <div key={item.id} className="flex align-items-center mb-3 gap-3">
                                                <img
                                                    src={prev}
                                                    alt="preview"
                                                    width="60"
                                                    height="60"
                                                    className='border border-2 border-gray-200'
                                                    style={{objectFit: "cover", borderRadius: "6px"}}
                                                />

                                                {/* uploader */}
                                                <FileUpload
                                                    mode="basic"
                                                    name="image"
                                                    accept="image/*"
                                                    maxFileSize={1024 * 1024}
                                                    auto={false}
                                                    chooseLabel="Select Image"
                                                    disabled
                                                    onSelect={(event: any) => {
                                                        const images = product?.images?.map((img: any) => {
                                                            if (img.id === item.id) {
                                                                return {
                                                                    ...img,
                                                                    image: event.files[0],
                                                                    preview:false
                                                                };
                                                            }
                                                            return img;
                                                        });

                                                        setProduct({
                                                            ...product,
                                                            images
                                                        });
                                                    }}
                                                />

                                                {/* remove */}
                                                <Button
                                                    icon="pi pi-trash"
                                                    severity="danger"
                                                    loading={rloading}
                                                    text
                                                    onClick={() => deleteImage(item?.id)}
                                                />

                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* Product PDF */}
                            <div className="col-12">
                                <label className="font-medium">Product PDF (10 mb max)</label>
                                <FileUpload
                                    name="demo[]"
                                    url="/api/upload"
                                    multiple={false}
                                    accept="application/pdf"
                                    maxFileSize={10*1024*1024}
                                    emptyTemplate={defaultPdfPreviewer}
                                    onSelect={onUploadPdf}
                                    onRemove={onRemovePdf}
                                />
                            </div>

                            <div className="col-12">
                                <label className="font-medium">Health Benefit *</label>
                                {/*<TinyEditor*/}
                                {/*    value={product.health_benefit}*/}
                                {/*    onChange={(content: string) =>*/}
                                {/*        setProduct((prev:any) => ({...prev, health_benefit:content}))*/}
                                {/*    }*/}
                                {/*/>*/}
                                <TextEditor
                                    value={product?.health_benefit || ''}
                                    setValue={(content: string) =>
                                        setProduct((prev: any) => ({
                                            ...prev,
                                            health_benefit: content,
                                        }))
                                    }
                                />
                            </div>

                            <div className="col-12">
                                <label className="font-medium">Dosage & Administration *</label>
                                {/*<TinyEditor*/}
                                {/*    value={product.dosage}*/}
                                {/*    onChange={(content: string) =>*/}
                                {/*        setProduct((prev:any) => ({...prev, dosage:content}))*/}
                                {/*    }*/}
                                {/*/>*/}
                                <TextEditor
                                    value={product?.dosage || ''}
                                    setValue={(content: string) =>
                                        setProduct((prev: any) => ({
                                            ...prev,
                                            dosage: content,
                                        }))
                                    }
                                />
                            </div>

                            <div className="col-12">
                                <label className="font-medium">Indication *</label>
                                {/*<TinyEditor*/}
                                {/*    value={product.indication}*/}
                                {/*    onChange={(content: string) =>*/}
                                {/*        setProduct((prev:any) => ({...prev, indication:content}))*/}
                                {/*    }*/}
                                {/*/>*/}
                                <TextEditor
                                    value={product?.dosage || ''}
                                    setValue={(content: string) =>
                                        setProduct((prev: any) => ({
                                            ...prev,
                                            dosage: content,
                                        }))
                                    }
                                />
                            </div>

                            <div className="col-12">
                                <label className="font-medium">Pack Size *</label>
                                {/*<TinyEditor*/}
                                {/*    value={product.pack_size}*/}
                                {/*    onChange={(content: string) =>*/}
                                {/*        setProduct((prev:any) => ({...prev, pack_size:content}))*/}
                                {/*    }*/}
                                {/*/>*/}
                                <TextEditor
                                    value={product?.pack_size || ''}
                                    setValue={(content: string) =>
                                        setProduct((prev: any) => ({
                                            ...prev,
                                            pack_size: content,
                                        }))
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* RIGHT SIDE – SEO INFO (5 COLS) */}
                <div className="col-12 md:col-5">
                    <div className="pl-2">
                        <Keyfacts product={product} setProduct={setProduct} refresh={refresh} setRefresh={setRefresh}/>
                        <div className="grid">
                            <div className="col-12">
                                <h4 className="mb-3">SEO Information</h4>
                            </div>

                            {/* Meta Title */}
                            <div className="col-12">
                                <label className="font-medium">Meta Title</label>
                                <InputText
                                    name="meta_title"
                                    value={product.meta_title || ""}
                                    onChange={handleChange}
                                    placeholder="Meta Title"
                                    className="w-full"
                                />
                            </div>

                            {/* Meta Author */}
                            <div className="col-12 md:col-6">
                                <label className="font-medium">Meta Author</label>
                                <InputText
                                    name="meta_author"
                                    value={product.meta_author || ""}
                                    onChange={handleChange}
                                    placeholder="Meta Author"
                                    className="w-full"
                                />
                            </div>

                            {/* Meta Robots */}
                            <div className="col-12 md:col-6">
                                <label className="font-medium">Meta Robots</label>
                                <Dropdown
                                    value={product.meta_robots || ""}
                                    options={[
                                        {label: "Index, Follow", value: "index, follow"},
                                        {label: "No Index, Follow", value: "noindex, follow"},
                                        {label: "Index, No Follow", value: "index, nofollow"},
                                        {label: "No Index, No Follow", value: "noindex, nofollow"}
                                    ]}
                                    onChange={(e) =>
                                        setProduct({...product, meta_robots: e.value})
                                    }
                                    placeholder="Select Robots Option"
                                    className="w-full"
                                />
                            </div>

                            {/* Meta Description */}
                            <div className="col-12">
                                <label className="font-medium">Meta Description</label>
                                <InputTextarea
                                    name="meta_description"
                                    value={product.meta_description || ""}
                                    onChange={handleChange}
                                    rows={4}
                                    placeholder="Meta Description"
                                    className="w-full"
                                    autoResize
                                />
                            </div>

                            {/* Meta Keywords */}
                            <div className="col-12">
                                <label className="font-medium">Meta Keywords</label>
                                <InputText
                                    name="meta_keywords"
                                    value={product.meta_keywords || ""}
                                    onChange={handleChange}
                                    placeholder="keyword1, keyword2, keyword3"
                                    className="w-full"
                                />
                            </div>


                            {/* Meta Image Upload */}
                            <div className="col-12">
                                <label className="font-medium">Meta Image (1024 kB max)</label>
                                <FileUpload
                                    name="demo[]"
                                    url="/api/upload"
                                    multiple={false}
                                    accept="image/*"
                                    maxFileSize={1024 * 1024}
                                    emptyTemplate={defaultMetaImagePreviewer}
                                    onSelect={onMetaUpload}
                                    onRemove={onMetaRemove}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* ACTION BUTTONS */}
                <div className="col-12 flex justify-content-end gap-2 mt-3">
                    <Button label="Back" icon={"pi pi-chevron-left"} className="p-button-secondary" />
                    <Button loading={ploading} onClick={updateProduct} label="Update Product" icon="pi pi-check" />
                </div>
            </div>
        </Card>
    );
};

export default HerbalDetails;